"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SelectionController", {
    enumerable: true,
    get: function() {
        return SelectionController;
    }
});
let SelectionController = class SelectionController {
    hostConnected() {}
    hostDisconnected() {}
    /**
   * Clears the selection.
   */ clear() {
        this.selection.clear();
        this.host.requestUpdate();
    }
    /**
   * Adds an item to the selection.
   */ select(item) {
        this.selection.add(item);
        this.host.requestUpdate();
    }
    /**
   * Removes an item from the selection.
   */ deselect(item) {
        this.selection.delete(item);
        this.host.requestUpdate();
    }
    /**
   * Toggles the selection state of an item.
   * @param item The item to toggle.
   * @param checked Optional explicit state. If provided, sets the state to this value.
   */ toggle(item, checked) {
        const isSelected = this.selection.has(item);
        const shouldSelect = checked !== undefined ? checked : !isSelected;
        if (shouldSelect) {
            this.selection.add(item);
        } else {
            this.selection.delete(item);
        }
        this.host.requestUpdate();
    }
    /**
   * Checks if an item is selected.
   */ has(item) {
        return this.selection.has(item);
    }
    /**
   * Returns the size of the selection.
   */ get size() {
        return this.selection.size;
    }
    /**
   * Returns the selection as an array.
   */ get items() {
        return Array.from(this.selection);
    }
    constructor(host){
        this.selection = new Set();
        this.host = host;
        this.host.addController(this);
    }
};
